"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'rag.file.indexing_error': 'Indeksowanie pliku nie powiodło się. Spróbuj ponownie lub skontaktuj się z pomocą techniczną, jeśli problem będzie się powtarzał.',
};
